import { sarApi, transactionApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} id
   */
  async initSarManage({ commit, dispatch }, id) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchDetail', id),
      dispatch('fetchEffects'),
      dispatch('fetchTypes'),
      dispatch('fetchTxRules'),
      dispatch('fetchTxTypes'),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} id
   */
  async fetchDetail({ commit, rootGetters }, id) {
    const token = rootGetters['auth/token'];
    try {
      const response = await sarApi.requestDetail(token, id);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchEffects({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    commit('setEffects', []);
    try {
      const response = await sarApi.requestEffects(token);
      commit('setEffects', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchTypes({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    commit('setTypes', []);
    try {
      const response = await sarApi.requestTypes(token);
      commit('setTypes', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchTxRules({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestRules(token);
      commit('setTxRules', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   */
  async fetchTxTypes({ commit, rootGetters }) {
    const token = rootGetters['auth/token'];
    try {
      const response = await transactionApi.requestAlarmTypes(token);
      commit('setTxTypes', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   * @param {Object} payload
   */
  saveSar({ commit, getters }, payload) {
    const oldSar = getters['sar'];
    const sar = { ...oldSar, ...payload };
    commit('setSar', sar);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} getters
   * @param {Array.<Object>} data
   */
  saveFiles({ commit, getters }, data) {
    const oldSar = getters['sar'];
    if (oldSar['document_files']) {
      delete oldSar['document_files'];
    }
    const files = data.map((el) => el.file);
    const sar = { ...oldSar, ...{ document_files: files } };
    commit('setSar', sar);
  },
  /**
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} documentId
   * @param {String} sarId
   */
  async removeDocument(
    { commit, dispatch, rootGetters },
    { documentId, sarId },
  ) {
    const token = rootGetters['auth/token'];
    commit('setLoading', true);
    try {
      await sarApi.requestDeleteDocument(token, documentId);
      await dispatch('fetchDetail', sarId);
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setLoading', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} getters
   * @param {Object} rootGetters
   * @param {String} sarId
   * @param {Boolean} isClosed
   */
  async updateSar(
    { commit, dispatch, getters, rootGetters },
    { sarId, isClosed = false } = {},
  ) {
    const data = getters['sar'];
    data.issue = isClosed;
    const token = rootGetters['auth/token'];
    commit('setLoading', true);
    try {
      const response = await sarApi.requestUpdate({ token, sarId, data });
      if (response.data) {
        await dispatch('fetchDetail', sarId);
      }
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setLoading', false);
    }
  },
};
